import { render, staticRenderFns } from "./PropertyCarousel.vue?vue&type=template&id=72a12fce&scoped=true"
import script from "./PropertyCarousel.vue?vue&type=script&lang=js"
export * from "./PropertyCarousel.vue?vue&type=script&lang=js"
import style0 from "./PropertyCarousel.vue?vue&type=style&index=0&id=72a12fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a12fce",
  null
  
)

export default component.exports